/* global $, prestashop */

let map;
const infoWindows = [];
let markers = [];

function closeInfoWindows() {
    for (let i = 0; i < infoWindows.length; i++) {
        infoWindows[i].close();
    }
}

window.closeInfoWindows = closeInfoWindows;

function initPlMap() {
    if (document.getElementById('relay-point-map') !== null) {
        $.ajax({
            type: 'POST',
            url: '//' + window.location.host + '/module/b2bcarrier/ajax',
            data: {
                'ajax': 1,
                'adapter': 'ColissimoPointRetrait',
                'params': [],
                'address': []
            },
            dataType: 'json',
        }).done((pins) => {
            const mapOptions = {
                center: new google.maps.LatLng(46.5694082, -1.4527609),
                zoom: 10,
                maxZoom: 15,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false,
                fullscreenControl: false,
                clickableIcons: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            map = new google.maps.Map(document.getElementById('relay-point-map'), mapOptions);
            refreshPlMap(pins);
            const searchbox = new google.maps.places.Autocomplete(document.getElementById('relay-point-input'));
            searchbox.addListener('place_changed', () => {
                closeInfoWindows();
                const place = searchbox.getPlace();

                if (typeof place.geometry !== 'undefined') {
                    for (let i = 0; i < markers.length; i++) {
                        markers[i].setMap(null);
                    }

                    markers = [];
                    $.ajax({
                        type: 'POST',
                        url: '//' + window.location.host + '/module/b2bcarrier/ajax',
                        data: {
                            'ajax': 1,
                            'adapter': 'ColissimoPointRetrait',
                            'params': [],
                            'address': place.address_components
                        },
                        dataType: 'json',
                    }).done((data) => {
                        refreshPlMap(data)
                    })
                }
            });
        });
    }
}

window.initPlMap = initPlMap;

function refreshPlMap(pins) {
    const blocks = [];

    if (Object.keys(pins).length) {
        for (let i = 0; i < pins.length; i++) {
            const position = new google.maps.LatLng(pins[i].latitude, pins[i].longitude);

            if (i === 0) {
                map.setCenter(position);
            }

            const marker = new google.maps.Marker({
                map: map,
                position: position,
                title: pins[i].name,
                id: pins[i].id,
            });
            let openingTime = pins[i].openingTime;
            openingTime = openingTime.replace(/<div class="relay-point-day">/g, '');
            openingTime = openingTime.replace(/<\/div>/g, "\n");
            let checked = '';

            if (pins[i].selected === 1) {
                checked = ' checked';
                $('#relay-points textarea').text(openingTime);
            }

            const block = '<div class="relay-point-radio">' +
                '<div class="relay-point-number fw-bold">' + (i + 1) + '</div>' +
                '<div class="form-check">' +
                '<input class="form-check-input" type="radio" name="relay_point" value="' + pins[i].id + '" ' + checked + '>' +
                '<div class="relay_point_info">' + openingTime + '</div>' +
                '</div>' +
                '</div>' +
                '<div class="relay-point-info w-100">' +
                '<div class="relay-point-name" title="' + pins[i].name + '">' + pins[i].name + '</div>' +
                '<div class="relay-point-address">' + pins[i].address + '</div>' +
                '<div class="relay-point-opening_time">' + pins[i].openingTime + '</div>' +
                '<div class="relay-point-action"><a href="#" data-id="' + pins[i].id + '">Choisir ce point relais</a></div>' +
                '</div>';
            const infoWindow = new google.maps.InfoWindow({
                content: '<div class="relay-point-info-window">' + block + '</div>'
            });
            marker.addListener('click', () => {
                closeInfoWindows();
                infoWindow.open(map, marker);
            });
            markers.push(marker);
            infoWindows.push(infoWindow);
            blocks.push('<li class="relay-point-pin gap-3 border border-1" data-id="' + pins[i].id + '">' + block + '</li>');
        }
    }

    if (blocks.length) {
        let $pinContainer = $('#relay-point-pins');

        if ($pinContainer.length) {
            $pinContainer.html('');
        } else {
            $('#relay-points').append('<ul id="relay-point-pins"></ul>');
            $pinContainer = $('#relay-point-pins');
        }

        for (let i = 0; i < blocks.length; i++) {
            $pinContainer.append(blocks[i]);
        }
    }
}

window.refreshPlMap = refreshPlMap;

$(document).ready(() => {
    prestashop.on('selectRelayPoint', (params) => {
        if (typeof params.relay_point === 'undefined' || 0 === params.relay_point.length) {
            return;
        }

        console.log('Relay point selected');
        const pinId = params.relay_point.closest('.relay-point-pin').attr('data-id');

        for (let i = 0; i < markers.length; i++) {
            if (markers[i].id === pinId) {
                google.maps.event.trigger(markers[i], 'click');
            }
        }

        $('.relay-point-radio input').prop('checked', false);
        params.relay_point.prop('checked', true);
        $('#relay-points textarea').text(params.relay_point.siblings('.relay_point_info').text());
    });

    $(document).on('click', '.relay-point-radio input', (event) => {
        console.log('click');
        prestashop.emit('selectRelayPoint', {
            relay_point: $(event.currentTarget)
        });

        if ($('.js-cart-payment-step-refresh').length) {
            $('.js-cart-payment-step-refresh').remove();
        }
    });

    $(document).on('click', '.relay-point-action a', (event) => {
        event.preventDefault();
        const $container = $('#relay-points');
        const $pin = $('.relay-point-pin[data-id="' + $(event.currentTarget).attr('data-id') + '"]');
        const $pinFirst = $('.relay-point-pin:eq(0)');
        $pin.find('input').trigger('click');
        $container.animate({
            scrollTop: $pin.offset().top - $pinFirst.offset().top
        });
    });

    $('#relay-point-input').on('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    });
});
